import React, { useCallback, useMemo, useContext } from 'react';
import ItemContent from '../../components/ItemContent/ItemContent';
import useDescLangs from '../../utils/useDescLangs';
import { useTranslation } from 'react-i18next';
import { IEditForm } from '../../types/interfaces/IEditForm';
import LabelWithPars from '../../components/LabelWithPars/LabelWithPars';
import tPaths from '../../utils/tPaths';
import { NSNotifications } from '../../types/interfaces/NSNotifications';
import { endpoints } from '../../utils/endpoints';
import { EPaths } from '../../types/enums/EPaths';
import { SessionContext } from '../../contexts/session/SessionContext';
import { CircularProgress } from '@material-ui/core';
import { EMailTemplateTypes } from '../../types/enums/EMailTemplateTypes';

const VerifyEmail = () => {
  const { languagesList, reduceLangsList } = useDescLangs();
  const { t } = useTranslation();

  const { permissions } = useContext(SessionContext);

  const descriptionMapper = useCallback(
    (data: NSNotifications.IDetails[], key: string): IEditForm[][] => {
      const items: IEditForm[][] = [
        [
              {
                type: 'title',
                label: data[0].displayName,
                fieldName: data[0]._id,
              },
              {
                type: 'input',
                fieldName: `subject${data[0]._id}`,
                label: (
                  <LabelWithPars
                    label={t(tPaths.editFormLabels.subject)}
                    info={key.toUpperCase()}
                  />
                ),
                initialValue: data[0].subject[key],
              },
              {
                type: 'input',
                multiline: true,
                fieldName: `content${data[0]._id}`,
                label: (
                  <LabelWithPars
                    label={t(tPaths.editFormLabels.content)}
                    info={key.toUpperCase()}
                  />
                ),
                initialValue: data[0].content[key],
              },
            ],
      ];
      return items;
    },
    [t],
  );

  const tabs = useMemo(
    () => [...languagesList.map((lang) => ({ key: lang.key, label: lang.display }))],
    [languagesList],
  );

  const tabsContentMapper = useCallback(
    (data: NSNotifications.IDetails[]) => ({
      ...languagesList.reduce(
        (acc, cv) => ({
          ...acc,
          [cv.key]: descriptionMapper(data, cv.key),
        }),
        {},
      ),
    }),
    [descriptionMapper, languagesList],
  );

  const updateDataFormatter = useCallback(
    (fields: any, data: NSNotifications.IDetails[]) => {
      //TODO remove field template, return object itself
      return data.map((template) => ({
        ...template,
        // displayName: template.displayName,
        // _id: template._id,
        content: reduceLangsList(fields, `content${template._id}`),
        subject: reduceLangsList(fields, `subject${template._id}`),
      }));
      
    },
    [reduceLangsList],
  );

  // console.log(tabs);

  return (
    <>
      {languagesList.length ? (
        <ItemContent
          title={t(tPaths.itemContent.editEmailTemplate)}
          path={EPaths.Notifications}
          tabs={tabs}
          tabsContentMapper={tabsContentMapper}
          updateDataFormatter={updateDataFormatter}
          apiUrl={endpoints.notifications([EMailTemplateTypes.VERIFY_EMAIL])}
          editable={permissions.notifications.edit}
          backButton={false}
        />
      ) : (
        <CircularProgress />
      )}
    </>
  );
};

export default VerifyEmail;
